require('./angular-messages');
module.exports = 'ngMessages';



// WEBPACK FOOTER //
// ./node_modules/angular-messages/index.js